export abstract class AbLoad {
  abstract habilitar(mensagem?: string);
  abstract desabilitar();
}